import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorHandler from '../../components/error-handler/error-handler';

type ErrorPageProps = {
  errorCode: number;
};

const ErrorPage = ({ errorCode = 500 }: ErrorPageProps): JSX.Element => {
  const { t } = useTranslation();
  const errorMessage = t(errorCode >= 400 && errorCode < 500 ? 'error4xx' : 'error5xx');

  return (
    <ErrorHandler title={`${errorCode} - ${errorMessage}`} id="support-form-error-page">
      {t(errorCode === 504 ? 'support.supportPage.body504Error' : 'error5xx')}
    </ErrorHandler>
  );
};

export default ErrorPage;
